import { render, staticRenderFns } from "./CourseViewer.vue?vue&type=template&id=1c7829cf"
import script from "./CourseViewer.vue?vue&type=script&lang=js"
export * from "./CourseViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports